import axios from "axios";
import { toast } from "react-toastify";
import https from "https";
import {
  adminPrefix,
  providerPrefix,
  studentPrefix,
} from "configs/routePrefix";
import store from "store"
 
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.httpsAgent = new https.Agent({ rejectUnauthorized: false });

axios.interceptors.response.use(null, async (error) => {
      const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (error.response && error.response.status === 401) {
    if (error.response.data.data.prefix === "admin") {
      let AdminAuthService = await import("./Admin/AuthService");
      AdminAuthService.logout();
      window.location = `${adminPrefix}/login`;
    } else if (error.response.data.data.prefix === "client") {
      let AuthService = await import("./Website/AuthService");
      AuthService.logout();
      window.location = `/`;
    }
     else if (error.response.data.data.prefix === "salesRep") {
      let SellerAuthService = await import("./Provider/AuthService");
      SellerAuthService.logout();
      window.location = `${providerPrefix}/login`;
    }
  }
  if (!error.message) {

  }else if (!expectedError) {

    // toast.error("An unexpected error occurred.");
  } else {
    if(error.response.data.error === 'Incorrect email or password!' || 
      error.response.data.error === "The email must be a valid email address." ||
      error.response.data.error === "The email or password you entered is invalid"){
      toast.error(error.response.data.error);
    }
    return error.response.data.error
   }

  // return Promise.reject(error);
});

function setJwt(jwt) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;
}
function setLang(lang) {
  let lan=store.getState().Auth.lang.length ? store.getState().Auth.lang :"en"  ;
  axios.defaults.headers.common["lang"] = lan
 
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
  setLang
};